module.exports = __webpack_public_path__ + "media/icons/suitcase-money-98d9f128.png";